import { useEffect, useState } from "react";
import { groupApi } from "../api/group.service";
import { AttendantType, PagingType } from "../types";

export const useGetAttendants = (
  id: string,
  initialParams?: Record<string, any>
) => {
  const [params, setParams] = useState<Record<string, any>>(
    initialParams || {}
  );
  const [data, setData] = useState<AttendantType[]>([]);
  const [paging, setPaging] = useState<PagingType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchData = async (id: string, fetchParams: Record<string, any>) => {
    try {
      setLoading(true);

      const response: any = await groupApi.getGroupAttendants(id, fetchParams);

      setData(response?.data?.data?.attendants ?? []);
      setPaging(response?.data?.data?.paging ?? null);

      return true;
    } catch (err: any) {
      console.log("Get group attendants failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(id, params);
  }, [JSON.stringify(params)]);

  return {
    data,
    fetchData,
    paging,
    loading,
    error,
    params,
    setParams,
  };
};
